<template>
  <div>
    rrrr
  </div>
</template>

<script>
import {
  validate
} from 'utils/validate'
import {
  next
} from '../status.js'
const AbnormalReasonType = 'LAB_SAMPLES_RECEIVED__UNQUALIFIED_REASON'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    detailIn: {
      type: Boolean,
      default: false
    },
    orderStatus: [Array]
  },
  components: {
  },
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    isUCAS () {
      return this.$store.state.saasConfig.tenant === 'ucas'
    },
    // 是否需初始排版
    isSelectPlate () {
      return !this.order.customerBoardNumber
    }
  },
  data () {
    return {
      curparams: {},
      options: [],
      title: '待分派',
      form: {
      },
      pass: false,
      reasonObj: {
        have: false,
        reasons: []
      },
      reasonProps: {
        label: 'name',
        value: 'id'
      },
      showDialog: false,
      dialog_title: '选择样本板',
      selectMaterials_info: [],
      layoutData: null,
      pictureUrl: [],
      picture_params: {
        resourceName: 'order',
        objectId: this.order.id
      },
      productionTaskDetail: {}
    }
  },
  methods: {
    getTask (val) {
      console.log('--------------', val)
      this.productionTaskDetail = val
      this.form.reactionPlateId = val.id
      this.showDialog = false
    },
    formValidata () {
      return validate(this, this.form)
    },
    getReason (val) {
      for (var i in this.options) {
        if (this.options[i].id === val) {
          return this.options[i].name
        }
      }
    },
    creatTask () {
      this.$router.push('/trust-deed-form/false/0')
    },

    next () {
      let data = {
        orderIds: [this.order.id],
        billId: this.order.billId,
        action: this.status
      }
      return next.call(this, data)
    },
    getAbnormalReason () {
      this.$store.dispatch('getAbnormalReason', AbnormalReasonType).then(res => {
        this.options = res
        this.getReason()
      })
    },
    openDialog () {
      this.showDialog = true
    },
    closeDialog () {
      this.showDialog = false
    }
  },
  created () {
    console.log(22222)
    this.getAbnormalReason()
  }
}

</script>

<style module lang="less">
.specification-table-div {
  margin-bottom: 20px;
  padding: 10px 20px 30px;
}

.specification-table {
  display: table !important;
  width: 100%;
  border-collapse: collapse !important;

  th,
  tr {
    width: 100% !important;
    max-width: 100% !important;
    display: table-row !important;
    padding: 0 !important;
    list-style-type: none;
    justify-content: center !important;
    border-bottom: 1px solid #c6c9d3;
    color: #5b5b5b !important;
  }

  td {
    color: #5b5b5b !important;
    text-align: center;
    justify-content: flex-start !important;
    padding: 10px;
  }
}
</style>
